// extracted by mini-css-extract-plugin
module.exports = {"nextActivity":"nextActivity_3DEMp3s3","icon":"icon_3S-Il498","repeat":"repeat_3NSesDoI"};